<template>
  <v-container>
    <div>
      <v-alert
        text
        dense
        color="deep-orange"
        icon="mdi-text-search"
        border="left"
      >
        In order to see products, you need to add conditions to filter, then
        press <strong>Filter products</strong> button. If you want to see all
        products, just press <strong>Filter products</strong> button without any
        conditions added.
      </v-alert>
    </div>
    <div class="">
      <FilterForm
        @formatValues="formatFilterValues"
        :showButtons="true"
        ref="filterComponent"
      ></FilterForm>
    </div>

    <v-data-table
      class="mt-6"
      :headers="headers"
      :items="items"
      item-key="SKU"
      :single-expand="true"
      :expanded.sync="expanded"
      show-expand
      :search="search"
      dense
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"
      :footer-props="{
        'items-per-page-options': [50, 100, 150, 200, 500],
      }"
      height="65vh"
      fixed-header
    >
      <template v-slot:top>
        <v-text-field
          v-model="search"
          label="Search"
          class="mb-1"
          outlined
          dense
          hide-details="auto"
        ></v-text-field>
      </template>
      <template v-slot:[`item.Photos`]="{ item }">
        <tr v-for="(itm, p) in item.Photos" :key="p">
          <td v-if="p === 0">
            <v-img max-width="100px" :src="itm"></v-img>
          </td>
        </tr>
      </template>
      <template v-slot:[`item.Brand`]="{ item }">
        <tr>
          <td>
            <span>{{ item.Brand }}</span
            ><br />
            <span class="grey--text"> Currency: {{ item.Currency }} </span>
          </td>
        </tr>
      </template>
      <template v-slot:[`item.stock`]="{ item }">
        <v-chip small :color="item.stock < 1 ? 'grey' : 'green'" dark>
          {{ item.stock }}
        </v-chip>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              size="40"
              @click="openHistory(item)"
              color="accent"
              >mdi-eye-circle</v-icon
            >
          </template>
          <span>View product history</span>
        </v-tooltip>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <ProductInfo :product="item"></ProductInfo>
        </td>
      </template>
    </v-data-table>

    <ProductHistoryDialog
      :product="productForHistory"
      ref="productHistoryDialog"
    ></ProductHistoryDialog>
  </v-container>
</template>

<script>
import FilterForm from "@/components/organisms/FilterForm.vue";
import ProductInfo from "../organisms/ProductInfo.vue";
import ProductHistoryDialog from "../Descriptions/ProductHistoryDialog.vue";

export default {
  name: "Exported",
  props: {},
  components: {
    FilterForm,
    ProductInfo,
    ProductHistoryDialog,
  },
  data: () => ({
    headers: [
      { text: "PHOTO", value: "Photos", class: "footer" },
      { text: "SKU", value: "SKU", class: "footer" },
      { text: "BARCODE", value: "Barcode", class: "footer" },
      { text: "CATEGORY", value: "Category", class: "footer" },
      { text: "CONDITION", value: "Condition", class: "footer" },
      { text: "BRAND", value: "Brand", class: "footer" },
      { text: "RRP", value: "RRP", class: "footer" },
      { text: "HISTORY", value: "actions", class: "footer" },
    ],
    items: [],
    expanded: [],
    search: "",
    loading: false,
    loadingExport: false,
    exportHistory: [],
    productForHistory: {},
    options: {},
    totalItems: 0,
    currentFilters: [],
  }),
  watch: {
    options: {
      handler() {
        if (this.currentFilters.length > 0) {
          this.filterProducts(this.currentFilters);
        }
      },
      deep: true,
    },
  },
  methods: {
    openHistory(item) {
      this.productForHistory = item;
      this.$refs.productHistoryDialog.showDialog(item);
    },
    formatFilterValues(filters) {
      let finalData = [];
      let val = "";
      this.$refs.filterComponent.setLoading(true);

      finalData.push(["ExportState", "equals", "Exported"]);
      finalData.push(["Described", "equals", true]);

      if (filters.length > 0) {
        for (let obj of filters) {
          if (obj.condition == "Yes") {
            val = true;
          } else if (obj.condition == "No") {
            val = false;
          } else if (obj.property["type"] === "Number") {
            val = parseInt(obj.value);
          } else if (obj.property["type"] === "Array") {
            val = obj.value;
          } else {
            val = obj.value;
          }
          finalData.push([obj.property["name"], obj.condition, val]);
        }
      }
      
      this.currentFilters = finalData;
      this.filterProducts(finalData);
    },
    filterProducts(data) {
      const { page, itemsPerPage } = this.options;
      
      this.loading = true;
      
      this.$store
        .dispatch("filterProducts", {
          filters: data,
          page: page || 1,
          limit: itemsPerPage || 100
        })
        .then((response) => {
          // Handle new response format
          if (response.data.data) {
            this.items = response.data.data;
            this.totalItems = response.data.pagination?.total || response.data.data.length;
          } else {
            // Fallback for old format
            this.items = response.data;
            this.totalItems = response.data.length;
          }
          
          this.selected = [];
          this.CSVurl = "";
          this.loading = false;
          this.$refs.filterComponent.setLoading(false);
        })
        .catch((error) => {
          this.loading = false;
          this.$refs.filterComponent.setLoading(false);
          let errorMsg = "";
          errorMsg = error.response.data
            ? error.response.data
            : "Something went wrong while filtering.";

          this.$refs.filterComponent.setLoadingFailed(true, errorMsg);
          console.log(error);
        });
    },
    async formatExportHistory(data) {
      let result = [];
      for (const element of data[0]) {
        result.push({
          name: `${element.firstName} ${element.lastName}`,
          date: `${element.date.split("T")[0]} ${
            element.date.split("T")[1].split(".")[0]
          }`,
        });
      }
      this.exportHistory = result;
    },
  },
};
</script>